import * as contractActions from "@rentiohq/shared-frontend/dist/reduxV2/contract/contract.actions";
import * as contractSelectorsV2 from "@rentiohq/shared-frontend/dist/reduxV2/contract/contract.selectors";
import { ERentioMoveMovement } from "@rentiohq/shared-frontend/dist/reduxV2/contract/contract.types";
import { IRootStore } from "redux/reducers";
import {
  EField,
  IExtraData,
} from "./schema.requestRentioMoveServiceExit.types";

export const performingSubmitActionResultSelector =
  (contractId: string) => (state: IRootStore) =>
    contractSelectorsV2.isRequestingRentioMoveService(state, contractId);

export const submitActionCreator =
  (extraData: IExtraData) => (formData: any) => {
    const { contract } = extraData;
    // Always treat as empty property contract in exit flow
    const isVacancyContract = true;

    return contractActions.requestRentioMoveServiceStart.getAction({
      id: contract.id,
      data: {
        movement: ERentioMoveMovement.Exit,
        moveDate: formData[EField.MoveDate],
        services: formData[EField.Services],
        residentCount: formData[EField.ResidentCount],
        // For vacancy contracts: vacancy holder becomes newTenantAccountId
        // For regular exit: departing tenant info is provided
        newTenantAccountId: isVacancyContract
          ? formData[EField.VacancyPropertyContractHolder]?.[0]
          : formData[EField.DepartingTenant]?.[0],
        noContract: isVacancyContract,
        // Manual departing tenant info (when no account selected)
        departingTenantFirstName: !isVacancyContract
          ? formData[EField.DepartingTenantFirstName]
          : undefined,
        departingTenantLastName: !isVacancyContract
          ? formData[EField.DepartingTenantLastName]
          : undefined,
        departingTenantEmail: !isVacancyContract
          ? formData[EField.DepartingTenantEmail]
          : undefined,
      },
    });
  };
